import { t } from 'i18next'

import { FormGroup, Label, Radio } from '~/components/unform'

import { adSizeTypeOptions } from '../options'

export const TypeFields = ({
  onChange
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => (
  <FormGroup className="w-100">
    <Label
      text={t('rm:adsize.form.text.type')}
      helperText={t('rm:adsize.form.helpText.type')}
      htmlFor="type"
      isRequired
    />
    <Radio name="type" onChange={onChange} options={adSizeTypeOptions} />
  </FormGroup>
)
